var _path, _path2, _circle, _circle2, _rect, _rect2, _rect3, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPopup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 167,
    height: 110,
    viewBox: "0 0 167 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M111.137 32.2483L129.159 62.7815L116.256 67.3319L111.137 32.2483Z",
    fill: "#EAD300"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1641 64.5382L47.3983 61.9246L46.5568 72.62L19.1641 64.5382Z",
    fill: "#EA0000"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 80.9777,
    cy: 76.0285,
    r: 2.9621,
    fill: "#9F00EA"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 86.9038,
    cy: 46.4038,
    r: 6.91156,
    fill: "#EAA900"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 52.3438,
    y: 102.969,
    width: 19.7473,
    height: 9.87366,
    transform: "rotate(-45.5869 52.3438 102.969)",
    fill: "#EAA900"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 146.877,
    y: 33.5703,
    width: 5.9242,
    height: 9.87366,
    transform: "rotate(21.9912 146.877 33.5703)",
    fill: "#EA0000"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 78.8137,
    y: 24.715,
    width: 23.6968,
    height: 7.89893,
    transform: "rotate(-116.768 78.8137 24.715)",
    fill: "#EA0000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.00024 50.471C1.00024 50.471 13.6272 44.1818 16.4917 47.4782C18.0654 49.2891 19.2538 51.4826 17.8444 53.2646C16.758 54.6384 15.1894 54.8135 13.3515 54.4907C9.45962 53.8072 9.51865 48.4026 11.0809 45.0553C13.238 40.4338 24.6883 43.1616 24.6883 43.1616",
    stroke: "#05EA00",
    strokeWidth: 2.36968
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6074 88.864C44.6074 88.864 43.6462 83.1535 46.4049 82.0154C48.7226 81.0592 50.7319 85.2878 52.6363 83.7547C54.5653 82.2018 49.7499 79.7417 51.3181 77.8844C52.9686 75.9296 58.2684 77.8844 58.2684 77.8844",
    stroke: "#005EEA",
    strokeWidth: 2.36968
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.14 16.7847C38.14 21.6925 46.0063 25.671 40.5324 25.671C35.0586 25.671 30.6211 21.6925 30.6211 16.7847C30.6211 11.877 35.0586 7.89844 40.5324 7.89844C46.0063 7.89844 38.14 11.877 38.14 16.7847Z",
    fill: "#9F00EA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M153.529 74.5355C156.785 74.8632 159.949 69.911 159.583 73.5419C159.218 77.1728 156.283 79.8506 153.027 79.523C149.772 79.1953 147.429 75.9863 147.795 72.3553C148.16 68.7244 150.274 74.2079 153.529 74.5355Z",
    fill: "#005EEA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M123.432 82.9375L125.649 89.76L132.823 89.76L127.019 93.9766L129.236 100.799L123.432 96.5826L117.629 100.799L119.845 93.9766L114.042 89.76L121.215 89.76L123.432 82.9375Z",
    fill: "#05EA00"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3422 49.3672L53.6722 53.4607H57.9764L54.4943 55.9906L55.8243 60.0842L52.3422 57.5542L48.86 60.0842L50.1901 55.9906L46.7079 53.4607H51.0121L52.3422 49.3672Z",
    fill: "#EAD300"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopup);
export default __webpack_public_path__ + "static/media/popup.cd8fecf7d3875295bbbe2d30b021ca6c.svg";
export { ForwardRef as ReactComponent };